import { ChangeEvent, useId, useState } from "react";
import "../style.css";
import { UploadAndDisplayProfileImageProps } from "./model";

export const UploadAndDisplayProfileImage = (
  props: UploadAndDisplayProfileImageProps
) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const inputId = useId();

  const handleSelectImage = (event: ChangeEvent) => {
    const files = (event.target as HTMLInputElement).files;

    if (files) {
      if (files.length > 0) {
        setSelectedImage(files[0]);
        props.onImageSelected(files[0]);
      }
    }
  };

  const handleDivContainerClicked = () => {
    let inputElement = document.getElementById(
      `${inputId}`
    ) as HTMLInputElement;

   inputElement.click();

  };

  return (
    <div
      className="img-zone-container cursor-pointer relative "
      onClick={() => handleDivContainerClicked()}
    >
      <input
        type="file"
        id={inputId}
        className="file-upload hidden"
        accept=".jpg,.png,.gif"
        onChange={(event) => {
          handleSelectImage(event);
        }}
      />
      {selectedImage  || props.imageUrl != null ? (
         <div className="w-[78px] h-[78px] bg-white rounded-full flex">
        <div
          className="h-[56px] w-[56px] rounded-full bg-figmaSpecialBlue bg-opacity-25  m-auto flex items-center justify-center"
          style={{
            backgroundImage: `url(${props.imageUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover",
          }}
        >
        </div>
        </div>
      ) : (
        <div className="w-[78px] h-[78px] bg-white rounded-full flex">
          <div className="h-[56px] w-[56px] rounded-full bg-figmaSpecialBlue bg-opacity-25  m-auto flex items-center justify-center">
            <img src="/images/upload-icon.svg" />
          </div>
        </div>
      )}
    </div>
  );
};
